import Controller from "./checkInConfiguration.controller";
import template from "./checkInConfiguration.html";

const checkInConfiguration = {
  template,
  controller: Controller,
  bindings: {
    level: "=",
    levelId: "=",
    uiLayout: "=",
  },
};

export default checkInConfiguration;



// WEBPACK FOOTER //
// ./src/components/checkInConfiguration/checkInConfiguration.component.js